import styled from "@emotion/styled"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const RibbonLink = styled.a`
  flex: 1;
  width: 100%;
  font-family: ${theme.wild.font.dinamo.regular};
  font-size: 11px;
  line-height: 16px;
  padding: 8px 4px;

  .special-br-1 {
    display: none;
  }

  @media (min-width: 350px) and (max-width: 420px) {
    .special-br-1 {
      display: block;
    }
  }
  @media (min-width: 374px) {
    font-size: 12px;
  }
  @media (min-width: 1024px) {
    font-size: 14px;
    line-height: 20px;
  }
  @media (min-width: 1280px) {
    padding: 8px 0;
  }

  .desktop-only {
    display: none;
    @media (min-width: 1024px) {
      display: inline-block;
    }
  }

  &.ribbon-ab-test-a {
    padding: 16px 0 20px;
  }
`

export const RibbonContainer = styled.div`
  transition: none;

  background-color: ${theme.wild.color.men.brand.blue[40]};
  border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};

  &.men-ribbon-promo {
    background-color: ${theme.wild.color.nova.brand.accent[80]};

    //NT2-23169 Travel Kit GWP | Ribbons - 4/30 @ 10AM ET

    &.travel-promo {
      a,
      section {
        padding: 6px 4px;
      }

      @media (min-width: 1px) and (max-width: 579px) {
        a,
        section {
          transform: translate(19vw);
        }
      }

      @media (min-width: 1024px) and (max-width: 1400px) {
        a,
        section {
          transform: translate(60px);
        }
      }

      .body--regular {
        > span.font-dinamoBold {
          font-size: 14px !important;
        }

        @media (max-width: 767px) {
          span,
          em {
            font-size: 12px !important;
          }
        }

        @media (min-width: 768px) {
          > span.font-dinamoRegular {
            font-size: 14px !important;
          }
        }
      }

      a span:first-of-type,
      section > p span:first-of-type {
        &::before {
          content: "";
          display: inline;
          position: absolute;
          background-image: url("https://images.ctfassets.net/0rbfqd9c4jdo/4EdBRd3IGtxKg07cAYJkvn/99190be3ce75622e70f46525c99759a8/travel-kit-ribbon-mobile.png");
          background-size: contain;
          background-repeat: no-repeat;
          width: 166px;
          height: 51px;
          transform: translate(-110%, -3px);
          @media (min-width: 580px) {
            // transform: translate(-140%, 8px);
          }
          @media (min-width: 768px) {
            width: 180px;
            height: 51px;
            transform: translate(-110%, -10px);
          }
          @media (min-width: 1024px) {
            background-image: url("https://images.ctfassets.net/0rbfqd9c4jdo/2QPKElsnuQDjJnzvTZJPAN/9772b58810e33f78bc46abc3ba13dc9e/travel-kit-ribbon.png");
            width: 145px;
            height: 34px;
            transform: translate(-110%, -8px);
          }
        }
      }
    }
  }

  width: 100%;
  z-index: 11;
  display: flex;
  align-items: center;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 100px;

  &.travel-promo {
    min-height: 62px;
  }

  @media (min-width: 768px) {
    min-height: 33px;
    &.travel-promo {
      min-height: 59px;
    }
  }
  @media (min-width: 1024px) {
    box-shadow: none;
    box-sizing: border-box;
    position: relative;
    border-top-right-radius: 4px;
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    height: 35px;
    &.travel-promo {
      min-height: 35px;
    }

    top: 0;
    em {
      display: inline;
    }

    margin-top: 0;

    // workaround for the promo yellow borders
    &.men-ribbon-promo {
      border-bottom: 1px solid ${theme.wild.color.nova.brand.accent[80]};
      border-top: 1px solid ${theme.wild.color.nova.brand.accent[80]};
      border-right: 1px solid ${theme.wild.color.nova.brand.accent[80]};
      position: relative;
    }
  }

  em.display-nicely {
    display: inline;
    @media (min-width: 431px) and (max-width: 1024px) {
      display: block;
    }
  }
`
